import { Card, Flex, Text } from "components/Base";

interface Card7DProps {
  color: string;
  title: string;
  position: string;
  [key: string]: any;
}

function Card7D({ color, title, position, ...props }: Card7DProps) {
  const percentToHex = (percentNum = 0) =>
    Math.round((percentNum / 100) * 255)
      .toString(16)
      .padStart(2, "0");

  const bgColor = `${color}${percentToHex(20)}`;
  const circleColor = `${color}${percentToHex(80)}`;

  let circleStyle: any = {
    left: "-30%",
  };

  if (position === "right") {
    circleStyle = {
      right: "-30%",
    };
  }

  if (position === "center") {
    circleStyle = {
      left: "50%",
      transform: "translateX(-50%)",
    };
  }

  return (
    <Card
      boxShadow="none"
      backgroundColor={bgColor}
      br="18px"
      p="20px"
      w="223px"
      h="265px"
      position="relative"
      overflow="hidden"
      {...props}
    >
      <Text color={color} weight="$bold" fontSize="$2xl" lineHeight="32px">
        {title}
      </Text>
      <Flex
        w="160px"
        h="160px"
        br="$rounded-full"
        border={`solid 16px ${circleColor}`}
        p="16px"
        position="absolute"
        bottom="-30%"
        {...circleStyle}
      >
        <Flex w="96px" h="96px" br="$rounded-full" bg={circleColor} />
      </Flex>
    </Card>
  );
}

export default Card7D;
